module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "signup"
  }, [_c('div', {
    staticClass: "title-intro"
  }, [_c('router-link', {
    staticClass: "btn-back ls-float-left ls-ico-shaft-left",
    attrs: {
      "to": {
        name: 'auth'
      },
      "title": _vm.$t('signup.main.login')
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.create_account')))])], 1), _vm._v(" "), _c('flash-message'), _vm._v(" "), (_vm.errorStatus) ? _c('div', {
    staticClass: "ls-alert-danger"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('application.alert.warning')))]), _vm._v(" " + _vm._s(_vm.$t('signup.main.not_possible_create_account')) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.formSubmitted) ? _c('form', {
    staticClass: "ls-form row",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('fieldset', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "ls-box ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "title-form"
  }, [_c('h5', {
    staticClass: "ls-title-5"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('signup.main.person_data')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.name'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.name),
      expression: "signup.seller.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('signup.placeholder.fill_full_name'),
      "name": _vm.$t('signup.main.name')
    },
    domProps: {
      "value": (_vm.signup.seller.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.name'))),
      expression: "errors.has($t('signup.main.name'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.name'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has('signup.seller.contact_attributes.area_code') || _vm.errors.has(_vm.$t('signup.main.phone'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.phone_number')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.full_phone),
      expression: "full_phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14'),
      expression: "'required|min:14'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.phoneMask),
      expression: "phoneMask"
    }],
    attrs: {
      "type": "tel",
      "maxlength": "16",
      "placeholder": _vm.$t('signup.placeholder.phone'),
      "name": _vm.$t('signup.main.phone')
    },
    domProps: {
      "value": (_vm.full_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.full_phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('signup.seller.contact_attributes.area_code') || _vm.errors.has(_vm.$t('signup.main.phone'))),
      expression: "errors.has('signup.seller.contact_attributes.area_code') || errors.has($t('signup.main.phone'))"
    }],
    staticClass: "ls-help-message ls-position-relative"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.phone'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.account_type'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.account_type')))]), _vm._v(" "), _c('label', {
    staticClass: "ls-label-text ls-float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.kind),
      expression: "signup.seller.kind"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "value": "P",
      "name": _vm.$t('signup.main.account_type')
    },
    domProps: {
      "checked": _vm._q(_vm.signup.seller.kind, "P")
    },
    on: {
      "__c": function($event) {
        _vm.signup.seller.kind = "P"
      }
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('signup.main.personal_account')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "ls-label-text ls-float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.kind),
      expression: "signup.seller.kind"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "value": "C",
      "name": _vm.$t('signup.main.account_type')
    },
    domProps: {
      "checked": _vm._q(_vm.signup.seller.kind, "C")
    },
    on: {
      "__c": function($event) {
        _vm.signup.seller.kind = "C"
      }
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('signup.main.customer_account')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row"
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.account_type'))),
      expression: "errors.has($t('signup.main.account_type'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.account_type'))))])])]), _vm._v(" "), (_vm.signup.seller.kind === 'C') ? _c('div', {
    attrs: {
      "id": "business-account"
    }
  }, [_c('div', {
    staticClass: "title-form"
  }, [_c('h5', {
    staticClass: "ls-title-5"
  }, [_c('i', {
    staticClass: "fa fa-building-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('signup.main.company_data')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.fantasy_name')) && _vm.signup.seller.kind === 'C'
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.fantasy_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.trade_name),
      expression: "signup.seller.trade_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('signup.placeholder.trade_name'),
      "name": _vm.$t('signup.main.fantasy_name')
    },
    domProps: {
      "value": (_vm.signup.seller.trade_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.trade_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.fantasy_name'))),
      expression: "errors.has($t('signup.main.fantasy_name'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.fantasy_name'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label ls-position-relative",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.cnpj'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.cnpj')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99.999.999/9999-99'),
      expression: "'99.999.999/9999-99'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.cnpj),
      expression: "signup.seller.cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:18|cnpj'),
      expression: "'required|min:18|cnpj'"
    }],
    attrs: {
      "type": "tel",
      "maxlength": "18",
      "placeholder": _vm.$t('signup.placeholder.cnpj'),
      "name": _vm.$t('signup.main.cnpj')
    },
    domProps: {
      "value": (_vm.signup.seller.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.cnpj = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.signup.seller.cnpj.length && !_vm.errors.has(_vm.$t('signup.main.cnpj'))) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.cnpj'))),
      expression: "errors.has($t('signup.main.cnpj'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.cnpj'))))])])]) : _vm._e(), _vm._v(" "), (_vm.signup.seller.kind === 'P') ? _c('label', {
    staticClass: "ls-label ls-position-relative",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.cpf'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.cpf')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|cpf'),
      expression: "'required|min:14|cpf'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.cpf),
      expression: "signup.seller.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }],
    attrs: {
      "type": "tel",
      "maxlength": "14",
      "placeholder": _vm.$t('signup.placeholder.cpf'),
      "name": _vm.$t('signup.main.cpf')
    },
    domProps: {
      "value": (_vm.signup.seller.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.cpf = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.signup.seller.cpf.length > 0 && !_vm.errors.has(_vm.$t('signup.main.cpf'))) ? _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errors.has(_vm.$t('signup.main.cpf'))) ? _c('small', {
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.cpf'))))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('fieldset', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "ls-box ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "title-form"
  }, [_c('h5', {
    staticClass: "ls-title-5"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('signup.main.address')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.postal_code'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.postal_code')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.postal_code),
      expression: "signup.seller.address_attributes.postal_code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|cep'),
      expression: "'required|min:10|cep'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99.999-999'),
      expression: "'99.999-999'"
    }],
    staticClass: "form-control ls-mask-cep",
    attrs: {
      "type": "tel",
      "maxlength": "10",
      "placeholder": _vm.$t('signup.placeholder.postal_code'),
      "name": _vm.$t('signup.main.postal_code')
    },
    domProps: {
      "value": (_vm.signup.seller.address_attributes.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.address_attributes.postal_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.postal_code'))),
      expression: "errors.has($t('signup.main.postal_code'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.postal_code'))))]), _vm._v(" "), _c('p', {
    staticClass: "ls-float-right"
  }, [_c('a', {
    attrs: {
      "href": "//www.buscacep.correios.com.br/sistemas/buscacep/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.main.forgot_zipcode')))])])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.street'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.street')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.street),
      expression: "signup.seller.address_attributes.street"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('signup.placeholder.street_avenue'),
      "name": _vm.$t('signup.main.street')
    },
    domProps: {
      "value": (_vm.signup.seller.address_attributes.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.address_attributes.street = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.street'))),
      expression: "errors.has($t('signup.main.street'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.street'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.address_number'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.address_number')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.number),
      expression: "signup.seller.address_attributes.number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "signup.seller.address_attributes.number",
      "placeholder": _vm.$t('signup.placeholder.number'),
      "name": _vm.$t('signup.main.address_number')
    },
    domProps: {
      "value": (_vm.signup.seller.address_attributes.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.address_attributes.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.address_number'))),
      expression: "errors.has($t('signup.main.address_number'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.address_number'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.neighborhood'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.neighborhood')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.neighborhood),
      expression: "signup.seller.address_attributes.neighborhood"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('signup.placeholder.neighborhood_example'),
      "name": _vm.$t('signup.main.neighborhood')
    },
    domProps: {
      "value": (_vm.signup.seller.address_attributes.neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.address_attributes.neighborhood = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.neighborhood'))),
      expression: "errors.has($t('signup.main.neighborhood'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.neighborhood'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.complement')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.complement),
      expression: "signup.seller.address_attributes.complement"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "signup.seller.address_attributes.complement",
      "placeholder": _vm.$t('signup.placeholder.optional')
    },
    domProps: {
      "value": (_vm.signup.seller.address_attributes.complement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.address_attributes.complement = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.city'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.city')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.city),
      expression: "signup.seller.address_attributes.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('signup.placeholder.your_city'),
      "name": _vm.$t('signup.main.city')
    },
    domProps: {
      "value": (_vm.signup.seller.address_attributes.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.address_attributes.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.city'))),
      expression: "errors.has($t('signup.main.city'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.city'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.state'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.state')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-custom-select",
    class: {
      'custom-danger': _vm.errors.has(_vm.$t('signup.main.state'))
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.address_attributes.state),
      expression: "signup.seller.address_attributes.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ls-select",
    attrs: {
      "name": _vm.$t('signup.main.state')
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signup.seller.address_attributes.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('signup.main.choose_state')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.state'))),
      expression: "errors.has($t('signup.main.state'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.state'))))])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('fieldset', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "ls-box ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "title-form"
  }, [_c('h5', {
    staticClass: "ls-title-5"
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('signup.main.access_data')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.mail'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.mail')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.email),
      expression: "signup.seller.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('signup.placeholder.mail_example'),
      "name": _vm.$t('signup.main.mail')
    },
    domProps: {
      "value": (_vm.signup.seller.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.mail'))),
      expression: "errors.has($t('signup.main.mail'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.mail'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('signup.main.password'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('signup.main.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.seller.password),
      expression: "signup.seller.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": _vm.$t('signup.placeholder.choose_password'),
      "name": _vm.$t('signup.main.password')
    },
    domProps: {
      "value": (_vm.signup.seller.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.seller.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('signup.main.password'))),
      expression: "errors.has($t('signup.main.password'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('signup.main.password'))))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-float-right ls-no-margin",
    attrs: {
      "disabled": _vm.disabled,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.buttonText) + "\n            ")])])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-277d87e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/signup/Main.vue
// module id = 745
// module chunks = 1